var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0543 3.94573C17.46 1.35142 13.2537 1.35142 10.6594 3.94574L5.85575 8.74941C4.59283 10.0123 4.0168 11.807 4.30879 13.569L5.01216 17.8135L2.24322 20.5824C1.91893 20.9067 1.91893 21.4325 2.24322 21.7568C2.56751 22.0811 3.09328 22.0811 3.41757 21.7568L6.18652 18.9878L10.431 19.6912C12.193 19.9832 13.9877 19.4072 15.2506 18.1443L20.0543 13.3406C22.6486 10.7463 22.6486 6.54005 20.0543 3.94573ZM6.18652 18.9878L5.1791 18.8209L5.01216 17.8135L14.7697 8.05598C15.094 7.73169 15.6197 7.73169 15.944 8.05598C16.2683 8.38026 16.2683 8.90604 15.944 9.23033L14.6214 10.5529H17.3141C17.7727 10.5529 18.1445 10.9247 18.1445 11.3833C18.1445 11.8419 17.7727 12.2137 17.3141 12.2137H12.9606L11.0984 14.076H13.791C14.2497 14.076 14.6214 14.4478 14.6214 14.9064C14.6214 15.365 14.2497 15.7368 13.791 15.7368H9.43758L6.18652 18.9878Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.a12e5fcd25e5359caecb29194af8cc86.svg";
export { ForwardRef as ReactComponent };